import { createContext, useEffect, useState } from 'react';
import { isClient, isServer } from '@microrealestate/commonui/utils';

import config from '../config';
import { enableStaticRendering } from 'mobx-react-lite';
import moment from 'moment';
import Store from './Store';

enableStaticRendering(isServer());

let _store;

export function getStoreInstance(initialData) {
  if (isServer()) {
    _store = new Store();
  }

  if (!_store) {
    _store = new Store();
    _store.hydrate(initialData);
    if (config.NODE_ENV === 'development') {
      window.__store = _store;
    }
  }

  return _store;
}

export const StoreContext = createContext();

export function InjectStoreContext({ children, initialData }) {
  const [store, setStore] = useState();

  useEffect(() => {
    const newStore = getStoreInstance(initialData);
    setStore(newStore);
    // Explicitly initialize whatsapp sockets when store is created on client
    try {
      if (newStore?.whatsapp?.initWhenReady) {
        // Run without await; it will internally wait for permissions
        newStore.whatsapp.initWhenReady();
      }
    } catch (err) {
      // Non-fatal; don't block rendering
      // console.warn('Failed to initialize whatsapp store:', err);
    }
  }, [initialData]);

  useEffect(() => {
    moment.locale(store?.organization?.selected?.locale ?? 'id');
    if (isClient() && config.NODE_ENV === 'development') {
      window.__store = store;
    }
  }, [store, store?.organization?.selected?.locale]);

  return store ? (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  ) : null;
}

export async function setupTenantsInStore() {
  if (!_store) {
    console.error('the store is not created. Fill tenants in store is not possible');
    return;
  }

  const selectedOrgId = _store.organization?.selected?._id;
  if (!selectedOrgId) {
    return;
  }

  try {
    await _store.tenant.fetch?.();
  } catch (err) {
    console.error('[setupTenantsInStore] fetch tenants failed:', err?.response?.data || err.message);
  }
}